import type { ComparativoUnidadesModel } from "../models/comparativoUnidadesModel"
import { ComparativoUnidadesActionsTypes } from "./comparativoUnidadesActions"
import type { ComparativoUnidadesAction } from "./comparativoUnidadesActions"

export function comparativoUnidadesReducer(
    state: ComparativoUnidadesModel,
    action: ComparativoUnidadesAction
): ComparativoUnidadesModel {
    switch (action.type) {
        case ComparativoUnidadesActionsTypes.CARREGAR:
            return { ...state, registros: action.payload, pesquisado: true }
        default:
            return state
    }
}
